window.SelectRadioUi = class
{
	
	constructor(select, options = {}) {
		const self = this;

		const $select = $(select).addClass('d-none').attr('plugin', '');
		$select.wrap(`<div class="d-flex flex-column"></div>`);
		const $wrapper = $select.parent();

		this.$wrapper = $wrapper;
		this.$select = $select;

		// Obtén todas las opciones del select
		var options = select.options;

		// Itera a través de las opciones y accede a sus propiedades
		for (var index = 0; index < options.length; index++) {
			const option = options[index];

			const $option = $(
			`<div class="btn btn-xl btn-no-animation justify-content-between" data-value="${option.value}">
				<div class="">${option.text}</div>
				<i class="fa-regular fa-circle font-size-16"></i>
			</div>`);

			if($select.attr('value') == option.value) {
				self.setSelected( $option );
			}

			$wrapper.append($option);

			$option.on('click', function(ev) {
				ev.stopPropagation();
				ev.preventDefault();
				$select.val( $(this).attr('data-value') ).trigger('change');
				self.setSelected( $(this) );
			});
		}

		if($select.attr('onSelect')) {
			$select.on('change', function(e) {

				var param = $(this).val();
				var func = $select.attr('onSelect').split('.');
				var funcObject = func[0]
				var funcFunction = func[1];

				// Acceder al objeto y llamar a la función
				var funcObject = window[funcObject]; // Acceder al objeto global (en este caso window)
				if (funcObject && typeof funcObject[funcFunction] === 'function') { // Verificar si el objeto existe y si la función es válida
					funcObject[funcFunction](param); // Llamar a la función del objeto
				}
			});
		}		
	}

	setSelected($option) {
		this.$wrapper.find('.fa-circle-dot').removeClass('fa-circle-dot text-primary').addClass('fa-circle');
		$option.find('i').removeClass('fa-circle').addClass('fa-circle-dot text-primary');
	}
	
}